import React from 'react';
import {
  validateMandatory,
  validatePostalCodeLength,
} from '../components/address-field-dapi/validate';
import { withLazyComponent } from './with-lazy-component';

const AddressFieldDapi = React.lazy(() => import('../components/address-field-dapi'));

export default function (dependencies) {
  const html = (props) => {
    const LazyComponent = withLazyComponent(AddressFieldDapi);
    return LazyComponent({ ...props, ...dependencies });
  };

  return {
    html,
    validators: [
      function (state, config, props) {
        const { street_name, street_number, zip } = state;

        if (!validateMandatory(street_name)) {
          return true;
        }

        if (!validateMandatory(street_number)) {
          return true;
        }

        if (!validateMandatory(zip)) {
          return true;
        }

        if (!validatePostalCodeLength(zip, props.globalConfig.countryCode)) {
          return true;
        }
      },
    ],
    config: {
      validators: ['mandatory'],
    },
  };
}
